var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForbiddenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 330 330",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.009,20c-7.132,0-13.881,1.667-19.878,4.633C246.686,10.026,231.496,0,214.009,0c-14.377,0-27.201,6.778-35.445,17.305 C171.498,12.688,163.061,10,154.009,10c-24.814,0-45,20.187-45,45v135.542L76.13,173.817c-6.204-3.108-13.168-4.751-20.139-4.751 c-24.813,0-45,20.187-45,45c0,17.157,9.536,32.584,24.889,40.264l128.492,64.254C179.014,326.053,195.49,330,212.026,330 c28.079,0,54.748-10.911,75.095-30.723c20.564-20.022,31.888-46.479,31.888-74.496V65C319.009,40.187,298.822,20,274.009,20z  M289.009,224.781c0,40.773-35.254,75.219-76.982,75.219c-12.005,0-23.467-2.746-34.066-8.162c-0.039-0.02-0.077-0.039-0.116-0.059 L49.299,227.499c-5.124-2.563-8.308-7.71-8.308-13.432c0-8.271,6.729-15,15-15c2.362,0,4.617,0.529,6.619,1.532l54.598,27.771 c4.652,2.367,10.197,2.144,14.643-0.583c4.447-2.727,7.158-7.57,7.158-12.787V55c0-8.271,6.729-15,15-15c8.27,0,15,6.729,15,15v80 c0,8.284,6.716,15,15,15c8.284,0,15-6.716,15-15V55V45c0-8.271,6.729-15,15-15c8.27,0,15,6.729,15,15v10v10v70 c0,8.284,6.716,15,15,15c8.284,0,15-6.716,15-15V65c0-8.271,6.729-15,15-15c8.271,0,15,6.729,15,15V224.781z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbiddenIcon);
export default __webpack_public_path__ + "static/media/forbidden_icon.e5d3090c76735db96b5c1e5513a1db3d.svg";
export { ForwardRef as ReactComponent };